import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import config from 'utils/config';
import { renderMindsetSDK3 } from './render/renderMindsetSDK3';
import { fetchCachedMindsetSettings } from './fetchCachedMindsetSettings';
import { serializeRenderCalls } from './serializeRenderCalls';
function addMindsetSDK3AgentIfRequired(_x) {
  return _addMindsetSDK3AgentIfRequired.apply(this, arguments);
}
function _addMindsetSDK3AgentIfRequired() {
  _addMindsetSDK3AgentIfRequired = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(containerId) {
    var initialQuestion,
      appUid,
      _yield$fetchCachedMin,
      agentUid,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          initialQuestion = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
          appUid = config.mindsetAppUid;
          if (appUid) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return");
        case 1:
          _context.next = 2;
          return fetchCachedMindsetSettings();
        case 2:
          _yield$fetchCachedMin = _context.sent;
          agentUid = _yield$fetchCachedMin.agentUid;
          if (agentUid) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          _context.next = 4;
          return renderMindsetSDK3({
            appUid: appUid,
            agentUid: agentUid,
            initialQuestion: initialQuestion,
            containerId: containerId,
            agentHeight: '100%'
          });
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _addMindsetSDK3AgentIfRequired.apply(this, arguments);
}
export var addMindsetDockAgentIfRequired = serializeRenderCalls(addMindsetSDK3AgentIfRequired);